/**
 * Created by anthony on 7/16/14.
 */
/**
 * Created by anthony on 7/14/14.
 */

var carouselModalFactory = angular.module('carouselModalFactory', []);
carouselModalFactory.factory('CarouselModalFactory', function($modal){
    var CarouselModalFactory = function(controller, template, model)
    {
        this.controller = controller;
        this.template = template;
        this.model = model;
    }


    CarouselModalFactory.prototype.initModal = function(familyIndex, add, index)
    {
        var parent = this;
        return $modal.open({
            templateUrl: this.template,
            controller: this.controller,
            resolve: {
                model: function () {
                    return parent.model

                },
                familyIndex: function () {
                    return familyIndex;
                }
            }
        })
    }



    CarouselModalFactory.prototype.initModalEdit = function(familyIndex, index)
    {
        this.initModal(familyIndex, false, index);
    }


    CarouselModalFactory.prototype.initModalAdd = function(familyIndex)
    {

        this.initModal(familyIndex, true);
    }


    return CarouselModalFactory;
});